<template>
	<div>
		<line-chart
			:datasets="datasets"
			:labels="labels"
			:options="options"
			:height="150"
			:width="300"></line-chart>
	</div>
</template>
<script>
	import { ref, computed, inject, onMounted, onBeforeUnmount, watch } from "vue";
	import { lineChart, lineChartHelper } from "@/components/charts";
	import numberFormat from "@/services/utils/numberFormat";

	export default {
		components: {
			lineChart
		},
		props: {
			samples: {
				type: Object,
				default: () => {
					return {};
				}
			},
			colors: {
				type: Array,
				default: () => {
					return ["#00aeef", "#d9017a"];
				}
			},
			metric: {
				type: String,
				default: () => {
					return "totalBillings";
				}
			},
			config: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		setup(props, context) {
			const moment = inject("$moment");
			const $financial = inject("$financial");

			const options = ref({
				responsive: true,
				plugins: {
					legend: {
						display: false
					},
					tooltip: {
						callbacks: {
							title: (tooltipItems) => {
								const tooltip = tooltipItems[0];
								const labelType = tooltip.dataset.label;
								if (labelType == "Compare") {
									const label = moment(tooltip.label, "[Q]Q YY");
									label.add(-1, "year");
									return label.format("[Q]Q YY");
								} else return tooltip.label;
							},
							label: (tooltipItem) => {
								return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(
									tooltipItem.raw
								);
							}
						}
					}
				},
				scales: {
					y: {
						suggestedMin: 0,
						ticks: {
							callback: function (value, index, ticks) {
								return numberFormat.compact(value, 0);
							},
							maxTicksLimit: 4
						}
					},
					x: {
						grid: { display: false }
					}
				}
			});

			const datasets = ref([]);
			const labels = ref([]);

			const BuildDatasets = () => {
				const sample = props.samples[props.metric];
				datasets.value = sample.datasets;
				labels.value = sample.labels;
			};
			BuildDatasets();

			return {
				labels,
				datasets,
				options
			};
		}
	};
</script>
